import { useEffect } from "react";
import styles from './about_me.module.scss';
import { motion } from "framer-motion";
import { SiTiktok, SiShopee, SiYoutube, SiFacebook } from "react-icons/si";
import { FiExternalLink } from "react-icons/fi";
import { trackEvent, trackVisitOnce } from "../../../utils/tracking";

// Cấu hình hiển thị theo từng nền tảng
const PLATFORMS = {
    shopee: { key: "shopee", label: "Xem ngay", Icon: SiShopee },
    lazada: { key: "lazada", label: "Xem ngay", Icon: FiExternalLink },
    other: { key: "other", label: "Xem ngay", Icon: FiExternalLink },
};

const getPlatform = (url = "") => {
    const u = url.toLowerCase();
    if (u.includes("shopee")) return PLATFORMS.shopee;
    if (u.includes("lazada")) return PLATFORMS.lazada;
    return PLATFORMS.other;
};

// Linh kiện dùng chung bắt buộc
const commonDroneParts = [
    { name: "Khung nhựa in 3D", desc: "Khung drone 5 inch, chịu va đập", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7r98o-ltylmloflman7c@resize_w900_nl.webp", url: "https://s.shopee.vn/9pdMK8JEIO" },
    { name: "Vít bake M2", desc: "Vít bake đầu bằng thân bu lông mạ đen M2", icon: "https://down-vn.img.susercontent.com/file/7db73ccc846c91a88e80852eec13e2dd.webp", url: "https://s.shopee.vn/40ficZd7Ts" },
    { name: "Sạc B3 Pro", desc: "Sạc B3 Pro 10W dành cho pin Lipo 2s, 3s", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7ra0g-m8n7dl6o0rk265.webp", url: "https://s.shopee.vn/9KhEw8W8Wa" },
    { name: "Mạch điều khiển ESP32", desc: "Chip ESP32-30p-TypeC-CP2102, tích hợp sẵn Wifi, Bluetooth", icon: "https://down-vn.img.susercontent.com/file/42de7e537a322307fb0f9ecf3943e6e6.webp", url: "https://s.shopee.vn/1VyEPJC297" },
    { name: "Cảm biến nghiêng MPU6050", desc: "Siêu nhạy, giúp drone cân bằng", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-22100-2oxg1ybsxviv1a.webp", url: "https://s.shopee.vn/AUuvE9Xvjl" },
    { name: "Mạch hạ áp 5V", desc: "Hạ điện áp cao từ pin xuống điện áp 5V ổn định", icon: "https://img.lazcdn.com/g/p/dc2004ce249ea8000536d505866f6c83.jpg_120x120q80.jpg_.webp", url: "https://s.lazada.vn/s.q5Yno" },
    { name: "Tụ hóa", desc: "Loại 470uF, chống nhiễu điện áp", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7ras8-m1rxcwj4wr7j89.webp", url: "https://s.shopee.vn/8KohksfTUn" },
    { name: "Tụ Gốm", desc: "Tụ Gốm loại 104, chống nhiễu tín hiệu tần số cao", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-22120-kw5es3rj4skv29.webp", url: "https://s.shopee.vn/80BrMSCOM1" },
    { name: "Bảng mạch đục lỗ", desc: "Kích thước 5x7cm để gắn các linh kiện", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-22100-emjtudjryuive2.webp", url: "https://s.shopee.vn/7VFRYQDQuQ" },
    { name: "Jump đơn cái", desc: "Hàng Rào Jump Đơn Cái 2.54mm", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7r98o-lknkn8ubsyogc7.webp", url: "https://s.shopee.vn/40fiZxT94l" },
    { name: "Trụ nhựa M2", desc: "Để cố định mạch lên khung", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-22100-yxxzofy874ivf8.webp", url: "https://s.shopee.vn/2qTbzvL8SV" },
    { name: "Đai ốc M2", desc: "Gắn kèm với trụ nhựa", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-22100-dep9rnu8y3ivae.webp", url: "https://s.shopee.vn/gP7PxSyoN" },
    { name: "Dây điện 18, 26, 30 awg", desc: "Dây điện chất lượng cao, chịu nhiệt tốt", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-824h4-melfsirhrxmvac.webp", url: "https://s.shopee.vn/5LAwya0rLM" },
    { name: "Tay điều khiển Pocket", desc: "Tay điều khiển hệ ELRS, tần số 2.4GHz", icon: "https://down-vn.img.susercontent.com/file/vn-11134201-7r98o-lzoijxky2t9dce.webp", url: "https://s.lazada.vn/s.q5Xa3" },
    { name: "Mạch thu RX", desc: "Mạch thu tín hiệu từ tay điều khiển hệ ELRS 2.4GHz", icon: "https://down-vn.img.susercontent.com/file/vn-11134201-7r98o-lzoo1hg8pv0t20.webp", url: "https://s.shopee.vn/7AccD3woXD" },
];

// 2 Option Động lực hiển thị trực quan song song/nối tiếp
const optionChill = {
    title: "🍃 Option 1: Cấu hình Bay Chill Chill",
    badge: "Tân thủ / Bay nhẹ nhàng",
    desc: "Động cơ vừa phải, dễ kiểm soát, chi phí thấp và an toàn.",
    items: [
        { name: "Motor 1503, 2750kV", desc: "Động cơ mạnh mẽ cho mini drone", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-7rd3x-lvzcymvls6h71d.webp", url: "https://s.shopee.vn/3LPsaIpb2r" },
        { name: "Cánh Quạt 4.5 inch", desc: "Siêu dẻo, bền, dùng vít M2", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-7rd43-lvzcyug2pgjgd4.webp", url: "https://s.shopee.vn/7fYrkOzDqZ" },
        { name: "Mạch điều tốc ESC 2s", desc: "Nhỏ gọn, chịu tải lên đến 8A", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-820l4-mepqi1tz400039.webp", url: "https://s.lazada.vn/s.q5Xni" },
        { name: "Pin 2s 95C 550mA", desc: "Pin lipo siêu nhẹ, dòng xả cao", icon: "https://down-vn.img.susercontent.com/file/vn-11134201-7r98o-lznjjppch1nl41.webp", url: "https://s.shopee.vn/20wN6J5xP8" },
    ]
};

const optionFPV = {
    title: "⚡ Option 2: Cấu hình Bay Chuẩn FPV",
    badge: "Hiệu năng cao / Tốc độ",
    desc: "Động cơ lực kéo khỏe, bay bốc, chi phí cao hơn.",
    items: [
        { name: "Motor RS2205", desc: "Động cơ lực kéo mạnh chuyên FPV", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-81ztc-mr8lypys4zd23c@resize_w900_nl.webp", url: "https://s.shopee.vn/2gC3qeiW0d" },
        { name: "Cánh 3 lá 5 inch", desc: "Cánh T5146 bám gió tốt, chịu áp lực cao", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-82588-mscflavt02ysc1.webp", url: "https://s.lazada.vn/s.q5YKG?t=p-iEbYYqE-s23gBldL" },
        { name: "Mạch điều tốc ESC 45A", desc: "Dòng chịu tải cực lớn, đáp ứng xả tức thì", icon: "https://img.lazcdn.com/g/ff/kf/Sb94ab39584064be28a28d00c6ae81af2k.jpg_120x120q80.jpg_.webp", url: "https://s.lazada.vn/s.q5Ypb" },
        { name: "Pin 3S 160C 650mA", desc: "Cung cấp nguồn xả cực đại cho trải nghiệm tốc độ", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-8262d-mm5teqbllzigce.webp", url: "https://s.shopee.vn/1BNG68c4em" },
    ]
};

const affiliateData = {
    tools: [
        { name: "Bộ kính lúp", desc: "Bộ kính lúp chất lượng có tay kẹp phóng đại x3.5", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-820l4-mdx0a6ggjg1t5c.webp", url: "https://s.shopee.vn/5ArfysWT9D" },
        { name: "Đồng hồ báo pin", desc: "Đồng Hồ Báo Pin Lipo 1s-8s Hú Còi Báo Hết Pin Hiển Thị Điện Áp Từng Cell Pin", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-7ra0g-mbievhp08pzh82.webp", url: "https://s.shopee.vn/60QmyU8mft" },
        { name: "Đồng hồ vạn năng", desc: "Đồng hồ vạn năng ANENG DT9205A", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7ras8-m5glt6at3vur17.webp", url: "https://s.shopee.vn/1127166Gfy" },
        { name: "Mỏ hàn TQ936", desc: "Mỏ hàn mini TQ936 60w 220v, nhiệt độ cao", icon: "https://down-vn.img.susercontent.com/file/3d55d25d32ed87c1090b5f6a831b414f.webp", url: "https://s.shopee.vn/1VyNax0hxU" },
        { name: "Bảng kê cắt tự liền", desc: "Bảng kê cắt tự liền A1 DIY Cutting Mat", icon: "https://down-vn.img.susercontent.com/file/e570539d2a6b2c0e6586ad58d255f1be.webp", url: "https://s.shopee.vn/7fZ0y1UwOn" },
        { name: "Bộ tua vít mini", desc: "Bộ Tua Vít Mini Đa Năng 24 Trong 1 Nhỏ Gọn", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7ras8-mdpsfnfi41tb21.webp", url: "https://s.shopee.vn/5VUWNCouih" },
        { name: "Thiếc hàn 63A", desc: "Thiếc hàn 63A-63% 0.8mm, dễ bám dính, ít khói", icon: "https://down-vn.img.susercontent.com/file/a24586eddc8a5570d4506ffb92f6b88a.webp", url: "https://s.shopee.vn/3VjRyjYfSY" },
        { name: "Nhựa thông", desc: "Hỗ trợ hàn mạch điện tử", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-81ztc-mmtqjjkelp1d7f.webp", url: "https://s.shopee.vn/2qTlBe2Dpf" },
        { name: "Mỡ hàn thiếc", desc: "Mỡ trợ hàn chì loại tốt siêu dính, giá siêu rẻ", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7r98o-lnnqosx82xnxf2.webp", url: "https://s.shopee.vn/7psR8tzJA5" },
        { name: "Cân điện tử", desc: "Cân Điện Tử Mini 0.1g Đến 10kg", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7ras8-mbf4pammbk6s23.webp", url: "https://s.shopee.vn/5q7MlPojoJ" },
        { name: "Dây XT30", desc: "Dây XT30 Hàn Sẵn Dây Silicone", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-7ras8-mdhl603teje9ff.webp", url: "https://s.shopee.vn/3VjS0Ga1m0" },
    ],
    drones: [
        { name: "E88 pro", desc: "Camera 4K mini cho drone tầm giá 400k", icon: "https://down-vn.img.susercontent.com/file/sg-11134201-82585-mr1lcdb51edjc6.webp", url: "https://s.shopee.vn/9zxiofq6VC" },
        { name: "DJI Neo", desc: "Flycam chuyên nghiệp giá rẻ của nhà DJI", icon: "https://down-vn.img.susercontent.com/file/vn-11134207-81ztc-mnv0jzb2rr480a@resize_w900_nl.webp", url: "https://s.shopee.vn/2LYHgrZnOz" },
    ]
};

const AboutMe = () => {

    useEffect(() => {
        trackVisitOnce();
    }, []);

    const handleProductClick = (item) => {
        trackEvent("click", { itemName: item.name, url: item.url });
    };

    // Component card dùng chung cho mọi danh sách
    const ProductCard = ({ item, onClick }) => {
        const { key, label, Icon } = getPlatform(item.url);
        return (
            <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${styles.productCard} ${styles[`platform_${key}`]}`}
                onClick={() => onClick(item)}
            >
                <div className={styles.productIcon}>
                    <img src={item.icon} alt={item.name} />
                </div>
                <div className={styles.productInfo}>
                    <span className={styles.productTitle}>{item.name}</span>
                    <span className={styles.productSubtitle}>{item.desc}</span>
                </div>
                <div className={styles.platformBtn}>
                    <Icon size={18} /> {label}
                </div>
            </a>
        );
    };

    return (
        <div id={styles.root}>
            <section id="about" className={styles.aboutSection}>
                <div className={styles.container}>

                    {/* Row: Profile Info */}
                    <div className={styles.topRow}>
                        <motion.div
                            className={styles.avatarColumn}
                            initial={{ opacity: 0, y: -20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className={styles.avatarWrapper}>
                                <img
                                    src="/logo512.png"
                                    alt="202 Black Boy"
                                    className={styles.avatar}
                                />
                            </div>

                            <div className={styles.socialLinks}>
                                <a href="https://www.tiktok.com/@202_black_boy" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                                    <SiTiktok />
                                </a>
                                <a href="https://www.youtube.com/@202blackboy" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                                    <SiYoutube />
                                </a>
                                <a href="https://www.facebook.com/blackboy202" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
                                    <SiFacebook />
                                </a>
                            </div>

                            <h1 className={styles.brandTitle}>BLACK BOY</h1>
                        </motion.div>

                        <motion.div
                            className={styles.textWrapper}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            <p className={styles.description}>
                                Ở đây mình tổng hợp lại toàn bộ link mua linh kiện, phụ kiện và đồ nghề mà mình đã sử dụng.
                            </p>
                        </motion.div>
                    </div>

                    {/* Section: Linh Kiện Chế Drone */}
                    <motion.div
                        className={styles.affiliateSection}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 className={styles.sectionTitle}>🚁 Linh Kiện Chế Drone</h2>

                        {/* Banner hướng dẫn rõ ràng */}
                        <div className={styles.guideBanner}>
                            💡 <strong>Mẹo chọn linh kiện:</strong> Chọn <strong>1 trong 2 Option Động Lực</strong> phù hợp với nhu cầu bên dưới. Các <strong>Linh Kiện Dùng Chung</strong> ở mục tiếp theo là cố định!
                        </div>

                        {/* Block Option 1: Bay Chill Chill */}
                        <div className={styles.optionBlock}>
                            <div className={styles.optionHeader}>
                                <div>
                                    <span className={styles.badgeChill}>{optionChill.badge}</span>
                                    <h3 className={styles.optionTitle}>{optionChill.title}</h3>
                                    <p className={styles.optionDesc}>{optionChill.desc}</p>
                                </div>
                            </div>
                            <div className={styles.productGrid}>
                                {optionChill.items.map((item, i) => (
                                    <ProductCard key={i} item={item} onClick={handleProductClick} />
                                ))}
                            </div>
                        </div>

                        {/* Block Option 2: Bay Chuẩn FPV */}
                        <div className={styles.optionBlock}>
                            <div className={styles.optionHeader}>
                                <div>
                                    <span className={styles.badgeFPV}>{optionFPV.badge}</span>
                                    <h3 className={styles.optionTitle}>{optionFPV.title}</h3>
                                    <p className={styles.optionDesc}>{optionFPV.desc}</p>
                                </div>
                            </div>
                            <div className={styles.productGrid}>
                                {optionFPV.items.map((item, i) => (
                                    <ProductCard key={i} item={item} onClick={handleProductClick} />
                                ))}
                            </div>
                        </div>

                        {/* Danh sách linh kiện dùng chung */}
                        <div className={styles.commonBlock}>
                            <div className={styles.commonHeader}>
                                <h3 className={styles.commonTitle}>⚙️ Linh Kiện Dùng Chung</h3>
                                <p className={styles.commonDesc}>Các linh kiện dưới đây được sử dụng chung cho cả 2 cấu hình trên.</p>
                            </div>
                            <div className={styles.productGrid}>
                                {commonDroneParts.map((item, i) => (
                                    <ProductCard key={i} item={item} onClick={handleProductClick} />
                                ))}
                            </div>
                        </div>
                    </motion.div>

                    {/* Section: Drone cho người tập chơi */}
                    <motion.div
                        className={styles.affiliateSection}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        <h2 className={styles.sectionTitle}>Drone cho người tập chơi</h2>
                        <div className={styles.productGrid}>
                            {affiliateData.drones.map((item, i) => (
                                <ProductCard key={i} item={item} onClick={handleProductClick} />
                            ))}
                        </div>
                    </motion.div>

                    {/* Section: Dụng Cụ & Đồ Nghề */}
                    <motion.div
                        className={styles.affiliateSection}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        <h2 className={styles.sectionTitle}>🛠️ Dụng Cụ & Đồ Nghề</h2>
                        <div className={styles.productGrid}>
                            {affiliateData.tools.map((item, i) => (
                                <ProductCard key={i} item={item} onClick={handleProductClick} />
                            ))}
                        </div>
                    </motion.div>

                </div>
            </section>
        </div>
    );
}

export default AboutMe;